import React, { useState } from 'react';
import { X, Loader2, Sparkles, Coins } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

export const money = (v, cur = 'cad') => `${{ cad: 'CA$', usd: 'US$' }[cur] || cur.toUpperCase() + ' '}${Number(v).toFixed(Number(v) % 1 ? 2 : 0)}`;

/** Buy a credit pack → Stripe Checkout (hosted). Returns to /feedback-credits?session_id=… */
export function PackPicker({ packs, currency, onClose }) {
  const [busy, setBusy] = useState('');
  const buy = async (p) => {
    setBusy(p.key);
    try {
      const { data } = await api.post('/api/feedback-credits/checkout', { pack_key: p.key, origin_url: window.location.origin });
      if (data?.url) { window.location.assign(data.url); return; }
      toast.error('Could not start the payment');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not start the payment'); }
    setBusy('');
  };
  const best = packs.reduce((m, p) => (p.credits / p.price > (m ? m.credits / m.price : 0) ? p : m), null);
  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose} data-testid="pack-picker">
      <div className="bg-white rounded-t-3xl sm:rounded-3xl w-full max-w-2xl p-5 sm:p-7 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-teal-700">Feedback credits</p>
            <h3 className="font-[Manrope] text-xl font-extrabold text-slate-900">Choose a pack</h3>
            <p className="text-sm text-slate-500 mt-1">Credits never expire while you're Pro. Secure card payment by Stripe.</p>
          </div>
          <button type="button" onClick={onClose} className="text-slate-400 hover:text-slate-700" data-testid="pack-picker-close"><X size={20} /></button>
        </div>
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
          {packs.map((p) => {
            const per = (p.price / p.credits * 100).toFixed(1);
            const hi = best && best.key === p.key;
            return (
              <button key={p.key} type="button" onClick={() => buy(p)} disabled={!!busy}
                className={`relative text-left rounded-2xl border-2 p-4 transition hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 ${hi ? 'border-teal-600 bg-teal-50/60' : 'border-slate-200 bg-white hover:border-teal-300'}`} data-testid={`pack-${p.key}`}>
                {p.badge && <span className={`absolute -top-2.5 left-4 text-[10px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5 ${hi ? 'bg-teal-600 text-white' : 'bg-amber-400 text-amber-950'}`}>{p.badge}</span>}
                <p className="text-xs font-semibold text-slate-500">{p.label || 'Pack'}</p>
                <p className="font-[Manrope] text-3xl font-extrabold text-slate-900 mt-1 inline-flex items-center gap-1.5"><Coins size={22} className="text-teal-600" /> {p.credits}</p>
                <p className="text-xs text-slate-500">credits</p>
                <p className="mt-3 text-lg font-bold text-slate-900">{money(p.price, currency)}</p>
                <p className="text-[11px] text-slate-500">{money(per / 100, currency)} per credit</p>
                <span className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-slate-900 text-white text-xs font-bold px-3 py-1.5">{busy === p.key ? <Loader2 size={12} className="animate-spin" /> : <Sparkles size={12} />} Buy</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
